import React from "react";
import { Card, Col, Row } from "react-bootstrap";
import Select, { SingleValue } from "react-select";
import { SetStateAction, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import { themeSelect } from "../../../shared/components/Select2";
import { getCorrectLanguage } from "../../../shared/functions/Functions";
import { IGlossary } from "../dto/IGlossary";
import { IExport } from "../../exports/dto/IExports";

interface IGlossaryProps {
  setIsMenuOpened: React.Dispatch<SetStateAction<boolean>>;
  state: IGlossary | undefined;
  setState: React.Dispatch<SetStateAction<IGlossary | undefined>>;
  clientList: IExport[];
}
export const GlossaryCreate = ({
  setIsMenuOpened,
  state,
  setState,
  clientList,
}: IGlossaryProps) => {
  const { t } = useTranslation();
  const { translationLanguageEnum } = useSelector(
    (state: IAllStates) => state.enums
  );
  function handleSelectSingle(selectedSingle: SingleValue<any | null>) {
    setState((prev: any) => ({
      ...prev,
      language: selectedSingle?.value as string,
    }));
  }
  function handleSelectSingleClient(selectedSingle: SingleValue<any | null>) {
    setState((prev: any) => ({
      ...prev,
      client: {
        id: selectedSingle?.value as number,
        name: selectedSingle?.label as string,
      },
    }));
  }
  const changeHandler = (event: any) => {
    const { name, value } = event.target;
    setState((prev: any) => ({ ...prev, [name]: value }));
  };
  return (
    <Card>
      <Card.Body>
        <Row>
          <Col md={4} className="mb-2">
            <label htmlFor="language" className="required-field">
              {`${t("global.language")}`}
            </label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              key={state?.id}
              defaultValue={
                state?.language && {
                  label: getCorrectLanguage(state?.language, t),
                  value: state?.language,
                }
              }
              onChange={(e) => {
                handleSelectSingle(e as any);
              }}
              // isMulti={true}
              options={(translationLanguageEnum as any)?.map(
                (language: string) => ({
                  value: language,
                  label: getCorrectLanguage(language, t),
                })
              )}
            />
          </Col>
          <Col md={4}>
            <label htmlFor="name" className="required-field">
              {`${t("glossary.word")}`}
            </label>
            <input
              type="text"
              name="word"
              className="form-control"
              value={state?.word ?? ""}
              required
              onChange={(e) => changeHandler(e as any)}
            />
          </Col>
          <Col md={4}>
            <label htmlFor="name" className="required-field">
              {`${t("glossary.alternative")}`}
            </label>
            <input
              type="text"
              name="alternative"
              className="form-control"
              value={state?.alternative ?? ""}
              required
              onChange={(e) => changeHandler(e as any)}
            />
          </Col>
        </Row>
        <Row>
          <Col md={4} className="mb-2">
            <label htmlFor="client">{`${t("global.client")}`}</label>
            <Select
              className="react-select-field"
              theme={themeSelect}
              key={state?.id}
              defaultValue={{
                label: state?.client?.name as string,
                value: state?.client?.id as number,
              }}
              onChange={(e) => {
                handleSelectSingleClient(e as any);
              }}
              // isMulti={true}
              options={(clientList as any)?.map((client: any) => ({
                value: client?.id,
                label: client?.name,
              }))}
            />
          </Col>
        </Row>
        <div className="col-12 my-2 d-flex justify-content-end text-align-center">
          <div>
            <button
              className="btn btn-info"
              onClick={() => {
                setIsMenuOpened(false);
                setState({} as any);
              }}
            >
              {t("global.cancel")}
            </button>
            <button className="btn btn-primary ms-3" type="submit">
              {state?.id ? `${t("global.update")}` : `${t("global.create")}`}
            </button>
          </div>
        </div>
      </Card.Body>
    </Card>
  );
};
